module.exports = __webpack_public_path__ + "img/equatorial-guinea.58dd3fe5.png";